module.exports = __webpack_public_path__ + "static/media/picture.3628aad6.svg";